export default function oppCreateQuote(data) {

    //TT TODO tady by se jeste asi mely kontrolovat cahnges (pokud nejsou prazdne (fieldy a lines), tak upozornit prez confirm)
    //TODO mozna vyvolat confirm

    
    const params = {action: "opp_create_quote", record : data.id};

    this.load();
    this.rest.post("customAction", params, resp => {
        if(resp.status){
            this.href("#detail/Quotes/"+resp.message.data.record);
        }
        else{
            this.unLoad();
            this.alert(resp.errorMessage.text);
        }
        
    });
    
}
